// 自定义配置
const API_BASEURL = "https://api.eraop.com";
// const API_BASEURL = "http://localhost:5678";
const PAGE_SIZE = 10;
const META_TITLE = "Eraop";
export default {
  API_BASEURL,
  PAGE_SIZE,
  META_TITLE
};



// WEBPACK FOOTER //
// ./src/config.js